import StoreTrackableInterface from "../../interfaces/storeTrackableInterface"

export default function <T extends StoreTrackableInterface> (builderModel: T) {
  return {
    actions: {
      async publish({commit, state}) {
        return builderModel.provider.publish(builderModel)
      },
      async publishingDependencies({commit, state}) {
        return builderModel.provider.publishingDependencies(builderModel)
      }
    },
  }
}
